import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type SnackbarSeverity = 'success' | 'info' | 'warning' | 'error'

export interface SnackbarMsg {
  id: number
  message: string
  severity: SnackbarSeverity
}

export interface UiState {
  sidebarOpen: boolean
  snackbar: SnackbarMsg | null
}

const initialState: UiState = {
  sidebarOpen: true,
  snackbar: null,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen
    },
    setSidebarOpen(state, action: PayloadAction<boolean>) {
      state.sidebarOpen = action.payload
    },
    showSnackbar(
      state,
      action: PayloadAction<{ message: string; severity?: SnackbarSeverity }>,
    ) {
      state.snackbar = {
        id: Date.now(),
        message: action.payload.message,
        severity: action.payload.severity ?? 'info',
      }
    },
    clearSnackbar(state) {
      state.snackbar = null
    },
  },
})

export const { toggleSidebar, setSidebarOpen, showSnackbar, clearSnackbar } = uiSlice.actions
export default uiSlice.reducer
